<template>
    <v-list two-line
            subheader>
        <v-subheader inset>FAQ</v-subheader>
        <v-list-tile v-for="item in items"
                     :key="item.title"
                     avatar>
            <v-list-tile-avatar>
                <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
            </v-list-tile-content>
        </v-list-tile>

        <v-list-tile avatar>
            <v-btn flat
                   outline
                   class="teal--text darken-2">Kangaruu</v-btn>
            <v-list-tile-content>
                <v-list-tile-title>Home</v-list-tile-title>
                <v-list-tile-sub-title>Return to Inbox</v-list-tile-sub-title>
            </v-list-tile-content>
        </v-list-tile>

    </v-list>
</template>

<script>
export default {
  data () {
    return {
      items: [
        { icon: 'fiber_new', iconClass: 'red--text darken-4', title: 'New Messages', subtitle: 'You have a new message.' },
        { icon: 'check_circle', iconClass: 'blue--text darken-4', title: 'Tendered', subtitle: 'Shipment has been tendered.' },
        { icon: 'exit_to_app', iconClass: 'teal', title: 'Logout', subtitle: 'Logout of Kangaruu.' },
        { icon: 'account_circle', iconClass: 'teal', title: 'Show Brokers/Shippers', subtitle: 'Manage your relationships.' },
        { icon: 'add', iconClass: 'teal', title: 'New Shipment', subtitle: 'Create a new shipment.' },
        { icon: 'settings', iconClass: 'teal', title: 'Settings', subtitle: 'Set-up user settings and notifications.' },
        { icon: 'search', iconClass: 'teal', title: 'Search Shipments', subtitle: 'Locate old shipments.' },
        { icon: 'keyboard_backspace', iconClass: 'teal', title: 'Go Back', subtitle: 'Return to previous screen.' }
      ]

    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/InboxHelp.vue